import { useSyncExternalStore } from 'react'

import { getTokenSnapshot, subscribeToken } from '@/apis/tokenStore'

/**
 * 현재 token 보유 여부를 reactive 하게 구독하는 hook.
 *
 * tokenStore.setToken 이 호출되면 useSyncExternalStore 가 자동 알림 → 컴포넌트 re-render.
 * lazy useState 와 달리 mount 후에도 token 변경(예: 비회원 → 회원가입 후 setToken)을 즉시 반영.
 *
 * 비교: hasToken() 직접 호출은 react 반응성 시스템 밖 — token 이 바뀌어도 컴포넌트가 모름.
 */
export function useHasToken(): boolean {
  const token = useSyncExternalStore(subscribeToken, getTokenSnapshot)
  return token !== null && token !== ''
}
